
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Les 12 pires erreurs d’un site Web professionnel",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Si l’on prédisait un boom numérique à l’an 2000, il semble que la révolution numérique ait conduit à une aire digitale dans laquelle posséder un site Internet n’est plus une option pour celles et ceux qui souhaitent perdurer.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Les 12 pires erreurs d’un site Web professionnel",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Si l’on prédisait un boom numérique à l’an 2000, il semble que la révolution numérique ait conduit à une aire digitale dans laquelle posséder un site Internet n’est plus une option pour celles et ceux qui souhaitent perdurer.",
        },
      ],
    };
  },
};
